import { useTranslation } from 'react-i18next';

import { ProductReadModel, useDeleteProductsByIdMutation } from '@client/api';
import { Button, Modal, ModalFooter } from '@client/toolkit';
import { DeleteConfirmationModalContent } from '../../../../components/delete-confirmation-modal-content/delete-confirmation-modal-content';

interface ProductDeleteModalProps {
  product: ProductReadModel;
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

export const ProductDeleteModal = ({ product, open, onCancel, onDelete }: ProductDeleteModalProps) => {
  const { t: tCommon } = useTranslation();

  const [mutation, { isLoading: isDeletingProduct }] = useDeleteProductsByIdMutation();

  const handleDeleteProduct = async () => {
    if (product?.id == null) return;
    const result = await mutation({ id: product.id });
    if (!('error' in result)) {
      onDelete();
    }
  };

  const handleClose = () => {
    onCancel();
  };

  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose} closeDisabled={isDeletingProduct}>
      <DeleteConfirmationModalContent name={product?.name ?? ''} />
      <ModalFooter className="justify-center">
        <Button color="danger" onClick={handleDeleteProduct} progressing={isDeletingProduct}>
          {tCommon('delete')}
        </Button>
        <Button color="primary-dark" onClick={handleClose}>
          {tCommon('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
